import React from 'react';
import { UserModel } from '../shared/types';

const initialValue = {
    user: {} as UserModel,
};

export const UserContext = React.createContext(initialValue);